export default function NullComponent() {
  return null
}
